import Injury from "../../components/svgs/injury";
import Behaviour from "../../components/svgs/bahviour";
import Fall from "../../components/svgs/fall";
import Elopement from "../../components/svgs/elopement";
import Death from "../../components/svgs/death";
import PropertyDamage from "../../components/svgs/propertyDamage";
import Abuse from "../../components/svgs/abuse";
import Equipment from "../../components/svgs/equipment";
import Skin from "../../components/svgs/skin";
import Choking from "../../components/svgs/choking";
import Medicine from "../../components/svgs/medicine";
import { IncidentType } from "../../types/fieldInstance.interface";
import Other from "../../components/svgs/other";

const incidents = [
  {
    id: IncidentType.AA,
    label: "Alleged Abuse",
    isActive: true,
    icon: Abuse,
  },
  {
    id: IncidentType.BP,
    label: "Behavioral Problem",
    isActive: false,
    icon: Behaviour,
  },
  {
    id: IncidentType.CH,
    label: "Choking",
    isActive: false,
    icon: Choking,
  },
  {
    id: IncidentType.DE,
    label: "Unanticipated Death",
    isActive: false,
    icon: Death,
  },
  {
    id: IncidentType.EL,
    label: "Elopement",
    isActive: false,
    icon: Elopement,
  },
  {
    id: IncidentType.EQ,
    label: "Equipment Related",
    isActive: false,
    icon: Equipment,
  },
  {
    id: IncidentType.FA,
    label: "Fall",
    isActive: false,
    icon: Fall,
  },
  {
    id: IncidentType.IU,
    label: "Injury of Unknown Origin",
    isActive: false,
    icon: Injury,
  },
  {
    id: IncidentType.MI,
    label: "Medication Incident",
    isActive: false,
    icon: Medicine,
  },
  {
    id: IncidentType.PD,
    label: "Property Damage",
    isActive: false,
    icon: PropertyDamage,
  },
  {
    id: IncidentType.SK,
    label: "Skin Issue",
    isActive: false,
    icon: Skin,
  },
  {
    id: IncidentType.OT,
    label: "Other",
    isActive: false,
    icon: Other,
  },
];

export default incidents;
